import React from 'react';
import LayoutDashboardIcon from '../../assets/icons/ic-layout-dashboard.svg?react';
import LineChartIcon from '../../assets/icons/ic-line-chart.svg?react';
import LayersIcon from '../../assets/icons/ic-layers.svg?react';
import AlertIcon from '../../assets/icons/ic-alert.svg?react';
import SettingsIcon from '../../assets/icons/ic-settings.svg?react';
import FlagIcon from '../../assets/icons/ic-flag.svg?react';
import FileCheckIcon from '../../assets/icons/ic-file-check.svg?react';
import GitCompareIcon from '../../assets/icons/ic-git-compare.svg?react';
import ListChecksIcon from '../../assets/icons/ic-list-checks.svg?react';
import Settings2Icon from '../../assets/icons/ic-settings2.svg?react';
//import UsersIcon from '../../assets/icons/ic-user.svg?react';
import LogOutIcon from '../../assets/icons/ic-log-out.svg?react';

interface IconWrapperProps {
  className?: string;
}

const IconWrapper: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => (
  <span className={className} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
    {children}
  </span>
);

export const DashboardIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <LayoutDashboardIcon />
  </IconWrapper>
);

export const FinancialIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <LineChartIcon />
  </IconWrapper>
);

export const HierarchyIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <LayersIcon />
  </IconWrapper>
);

export const RiskIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <AlertIcon />
  </IconWrapper>
);

export const ControlIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <SettingsIcon />
  </IconWrapper>
);

export const GapIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <FlagIcon />
  </IconWrapper>
);

export const CertificationIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <FileCheckIcon />
  </IconWrapper>
);

export const COSOIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <GitCompareIcon />
  </IconWrapper>
);

export const AuditIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <ListChecksIcon />
  </IconWrapper>
);

export const UserManagementIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <svg width="25" height="25" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.6663 16V14.6667C14.6663 13.9594 14.3854 13.2811 13.8853 12.781C13.3852 12.281 12.7069 12 11.9997 12H7.99967C7.29243 12 6.61415 12.281 6.11406 12.781C5.61396 13.2811 5.33301 13.9594 5.33301 14.6667V16M12.6663 6.66667C12.6663 8.13943 11.4724 9.33333 9.99967 9.33333C8.52692 9.33333 7.33301 8.13943 7.33301 6.66667C7.33301 5.19391 8.52692 4 9.99967 4C11.4724 4 12.6663 5.19391 12.6663 6.66667Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
  </IconWrapper>
);

export const SystemSettingsIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <Settings2Icon />
  </IconWrapper>
);

export const LogoutIcon: React.FC<IconWrapperProps> = ({ className }) => (
  <IconWrapper className={className}>
    <LogOutIcon />
  </IconWrapper>
);

